$(document).on("change", ".select__select", function() {
  const selectedOption = $(this).find("option:selected");
  const dataCharm = selectedOption.data("charm");

  console.log("Selected value:", selectedOption.val());
  console.log("data-charm attribute:", dataCharm);

  // Step 1: Hide all bracelet slots
  const slots = document.querySelectorAll('.bracelet-slot');
  slots.forEach(slot => slot.classList.add('hide'));

  // Step 2: Count how many slots have matching data-charm
  const count = Array.from(slots).filter(slot => {
    return Number(slot.getAttribute('data-slot')) < dataCharm;
  }).length;

  // Step 3: Show first 'count' number of slots
  for (let i = 0; i < count && i < slots.length; i++) {
    slots[i].classList.remove('hide');
  }

  // Optional: log how many are shown
  console.log("Number of slots to show:", count);
});
